<template>
    <li>
        <span>{{ property.name }}</span> = {{ value.value_varchar }}
    </li>
</template>

<script>
    export default {
        name: "ProductPropertyRow",
        props: {
            property: {
                type: Object,
                required: true,
            },
            value: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ProductPropertyRow.vue?84aa2760